<ng-container *ngIf="remainingSeconds$ | async as seconds">
	<div
		class="flex flex-col max-w-500 space-y-6 flex-auto justify-center text-center"
	>
		<app-icon [icon]="ICON.HOURGLASS" class="text-grey text-4xl"></app-icon>
		<h4>
			You are about to be logged off<br />in {{ seconds }} second{{
				seconds === 1 ? '' : 's'
			}}
		</h4>
		<p>Looks like you are inactive. Would you like to continue the session?</p>
		<div class="flex flex-auto space-x-6 justify-center">
			<app-button (click)="logoff(true)" btn="border" tabindex="2"
				>Log me out now</app-button
			>
			<app-button (click)="stayLoggedIn()" btn="primary" tabindex="1"
				>Keep me logged in</app-button
			>
		</div>
	</div>
</ng-container>
